import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import useFetch from "../../hooks/useFetch";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSync } from "@fortawesome/free-solid-svg-icons";

const languages = [
  { code: "en", label: "English" }, 
  { code: "hi", label: "हिंदी" },
  { code: "mr", label: "मराठी" }, 
  { code: "gu", label: "ગુજરાતી" },
  { code: "bn", label: "বাংলা" }, 
  { code: "ta", label: "தமிழ்" },
  { code: "te", label: "తెలుగు" }, 
  { code: "kn", label: "ಕನ್ನಡ" },
  { code: "ml", label: "മലയാളം" }, 
  { code: "pa", label: "ਪੰਜਾਬੀ" },
  { code: "as", label: "অসমীয়া" },
];

const HAFHAbout = ({ t, selectedLanguage, role, currentTheme }) => {

  const authState = useSelector((state) => state.authReducer);
  const [fetchData] = useFetch();
  const userCode = authState?.think5whyscode || "";
  const [language, setLanguage] = useState(selectedLanguage || "en");
  const [data, setData] = useState(null);
  const [lastFetchedLang, setLastFetchedLang] = useState(null);

  const fetchAbout = async (force = false) => {
    if (!force && lastFetchedLang === language && data) return;

    try {
      const res = await fetchData({
        url: "/hafh/operations/about/get",
        method: "post",
        data: {
          role,
          language,
        },
        headers: {
          Authorization: authState.token,
        },
      });

      if (res?.status) {
        setData(res.record || null);
        setLastFetchedLang(language);
      }

    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (authState?.token && role) {
      fetchAbout(true);
    }
  }, [authState?.token, role]);

  const handleLanguageChange = (e) => {
    setLanguage(e.target.value);
  };

  const canRefresh = lastFetchedLang !== language;

  return (
    <div className={`${currentTheme.card} border ${currentTheme.border} rounded-2xl p-4`}>

      {/* TOP CONTROLS */}
      <div className="flex justify-between items-center mb-3 gap-2">

        {/* LANGUAGE SELECT */}
        <select
          value={language}
          onChange={handleLanguageChange}
          className={`
            text-xs md:text-sm p-1 rounded-lg border
            ${currentTheme.border}
            ${currentTheme.bg}
            ${currentTheme.text}
          `}
        >
          {languages.map((lang) => (
            <option key={lang.code} value={lang.code}>
              {lang.label}
            </option>
          ))}
        </select>

        {/* REFRESH BUTTON */}
        <button
          onClick={() => fetchAbout(true)}
          disabled={!canRefresh}
          className={`
            w-20 lg:w-28
            text-xs lg:text-sm
            flex items-center justify-center gap-1
            px-2 py-1 rounded border
            transition-all duration-200

            ${
              canRefresh
                ? `${currentTheme.tabInactive} ${currentTheme.tabHover}`
                : "opacity-40 cursor-not-allowed"
            }
          `}
        >
          <FontAwesomeIcon icon={faSync} className="text-xs" />
          Refresh
        </button>
      </div>

      {/* CONTENT */}
      {!data ? (
        <div className={currentTheme.subText}>
          No About content available
        </div>
      ) : (
        <div>
          <h2 className={`font-semibold text-lg mb-2 ${currentTheme.text}`}>
            {data.title}
          </h2>

          <p className={`text-sm whitespace-pre-line ${currentTheme.subText}`}>
            {data.content}
          </p>
        </div>
      )}

    </div>
  );
};

export default HAFHAbout;